const useDebounceCallback = () => {
  let timeoutId = null

  return (callback, delay = 500) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(async () => {
      await callback()
    }, delay)
  }
}

export default useDebounceCallback